export const TOKEN_TYPE = 'Bearer '
export const REQUEST_HEADER_AUTH_KEY = 'Authorization'
export const endpoints = {
    REFRESH_TOKEN: '/admin/api/auth/refresh',
}
